import { useSuspenseQuery } from '@tanstack/react-query'
import ms from 'ms'

import { QUERY_KEYS } from '../constants/queryKeys'
import { sessionService } from '../lib/services/sessionService'
import { setSession } from '../store/slices/sessionSlice'
import { useAppDispatch } from './useAppDispatch'

export function useSessionQuery() {
  const dispatch = useAppDispatch()

  return useSuspenseQuery({
    queryKey: QUERY_KEYS.currentSession,
    staleTime: ms('2m'),
    queryFn: async () => {
      const session = await sessionService.getCurrentSession()

      dispatch(setSession(session || undefined))

      return session
    },
  })
}
